import { createVNode, mergeProps } from 'vue';

function icon(children, classes, style, on) {
  return createVNode("span", mergeProps({
    "contenteditable": "false",
    "class": classes ? `se-icon ${classes.join(' ')}` : 'se-icon',
    "style": style
  }, on), [children]);
}

export { icon };
//# sourceMappingURL=icon.js.map
